/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * jarvis/v1/api.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  JarvisServiceRunCodeBody,
  RpcStatus,
  V1CompareValuesRequest,
  V1CompareValuesResponse,
  V1ComputePatchedCodeRequest,
  V1ComputePatchedCodeResponse,
  V1DescribeGrammarRequest,
  V1DescribeGrammarResponse,
  V1ExtractBookFunctionRequest,
  V1ExtractBookFunctionResponse,
  V1ExtractInputRequest,
  V1ExtractInputResponse,
  V1ExtractOutputRequest,
  V1ExtractOutputResponse,
  V1GenerateSkeletonRequest,
  V1GenerateSkeletonResponse,
  V1GetExecutionOutputsResponse,
  V1PrepareCodeManifestRequest,
  V1PrepareCodeManifestResponse,
  V1RunCodeResponse,
  V1SearchBuiltinFunctionsRequest,
  V1SearchBuiltinFunctionsResponse,
  V1ValidateAopRequest,
  V1ValidateAopResponse,
  V1ValidateCodeRequest,
  V1ValidateCodeResponse,
  V1ValidatePatchRequest,
  V1ValidatePatchResponse,
} from '../models';

/**
 * @summary GetExecutionOutputs retrieves the output values from a completed execution.
Returns the map of named outputs that were set during execution using the
set_output() builtin function.
 */
export const getExecutionOutputs = (
  organization: string,
  workspace: string,
  execution: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GetExecutionOutputsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organization}/workspaces/${workspace}/executions/${execution}/outputs`,
    options,
  );
};

export const getGetExecutionOutputsQueryKey = (
  organization?: string,
  workspace?: string,
  execution?: string,
) => {
  return [
    `/api/v1/organizations/${organization}/workspaces/${workspace}/executions/${execution}/outputs`,
  ] as const;
};

export const getGetExecutionOutputsQueryOptions = <
  TData = Awaited<ReturnType<typeof getExecutionOutputs>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  execution: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExecutionOutputs>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetExecutionOutputsQueryKey(organization, workspace, execution);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExecutionOutputs>>
  > = ({ signal }) =>
    getExecutionOutputs(organization, workspace, execution, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organization && workspace && execution),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getExecutionOutputs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExecutionOutputsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExecutionOutputs>>
>;
export type GetExecutionOutputsQueryError = AxiosError<RpcStatus>;

export function useGetExecutionOutputs<
  TData = Awaited<ReturnType<typeof getExecutionOutputs>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  execution: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExecutionOutputs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExecutionOutputs>>,
          TError,
          Awaited<ReturnType<typeof getExecutionOutputs>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExecutionOutputs<
  TData = Awaited<ReturnType<typeof getExecutionOutputs>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  execution: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExecutionOutputs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExecutionOutputs>>,
          TError,
          Awaited<ReturnType<typeof getExecutionOutputs>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExecutionOutputs<
  TData = Awaited<ReturnType<typeof getExecutionOutputs>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  execution: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExecutionOutputs>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary GetExecutionOutputs retrieves the output values from a completed execution.
Returns the map of named outputs that were set during execution using the
set_output() builtin function.
 */

export function useGetExecutionOutputs<
  TData = Awaited<ReturnType<typeof getExecutionOutputs>>,
  TError = AxiosError<RpcStatus>,
>(
  organization: string,
  workspace: string,
  execution: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExecutionOutputs>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetExecutionOutputsQueryOptions(
    organization,
    workspace,
    execution,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary RunCode executes the provided SPy code and returns the execution status.
 */
export const runCode = (
  jarvisServiceRunCodeBody: JarvisServiceRunCodeBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1RunCodeResponse>> => {
  return axios.default.post(
    `/api/v1/organizations/startExecution.organization_id}/workspaces/startExecution.workspace_id}/executions:run`,
    jarvisServiceRunCodeBody,
    options,
  );
};

export const getRunCodeMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runCode>>,
    TError,
    { data: JarvisServiceRunCodeBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runCode>>,
  TError,
  { data: JarvisServiceRunCodeBody },
  TContext
> => {
  const mutationKey = ['runCode'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runCode>>,
    { data: JarvisServiceRunCodeBody }
  > = props => {
    const { data } = props ?? {};

    return runCode(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof runCode>>
>;
export type RunCodeMutationBody = JarvisServiceRunCodeBody;
export type RunCodeMutationError = AxiosError<RpcStatus>;

/**
 * @summary RunCode executes the provided SPy code and returns the execution status.
 */
export const useRunCode = <TError = AxiosError<RpcStatus>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runCode>>,
      TError,
      { data: JarvisServiceRunCodeBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof runCode>>,
  TError,
  { data: JarvisServiceRunCodeBody },
  TContext
> => {
  const mutationOptions = getRunCodeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary CompareValues compares two SPy values using the specified comparison operator
and returns the boolean result. Comparison semantics follow SPy's type system;
no implicit type coercion is performed. When the values cannot be compared
(e.g. operand types differ, or the operator is not defined for the operand
type such as ordering on a table), the response carries an IncomparableReason
instead of a boolean result.
 */
export const compareValues = (
  v1CompareValuesRequest: V1CompareValuesRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1CompareValuesResponse>> => {
  return axios.default.post(
    `/jarvis.v1.JarvisService/CompareValues`,
    v1CompareValuesRequest,
    options,
  );
};

export const getCompareValuesMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof compareValues>>,
    TError,
    { data: V1CompareValuesRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof compareValues>>,
  TError,
  { data: V1CompareValuesRequest },
  TContext
> => {
  const mutationKey = ['compareValues'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof compareValues>>,
    { data: V1CompareValuesRequest }
  > = props => {
    const { data } = props ?? {};

    return compareValues(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompareValuesMutationResult = NonNullable<
  Awaited<ReturnType<typeof compareValues>>
>;
export type CompareValuesMutationBody = V1CompareValuesRequest;
export type CompareValuesMutationError = AxiosError<RpcStatus>;

/**
 * @summary CompareValues compares two SPy values using the specified comparison operator
and returns the boolean result. Comparison semantics follow SPy's type system;
no implicit type coercion is performed. When the values cannot be compared
(e.g. operand types differ, or the operator is not defined for the operand
type such as ordering on a table), the response carries an IncomparableReason
instead of a boolean result.
 */
export const useCompareValues = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof compareValues>>,
      TError,
      { data: V1CompareValuesRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof compareValues>>,
  TError,
  { data: V1CompareValuesRequest },
  TContext
> => {
  const mutationOptions = getCompareValuesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ComputePatchedCode applies a patch to a failed execution and returns the complete patched SPy code.
The request contains the execution resource name and the patch to apply.
The response contains the complete patched SPy code ready for re-execution.
 */
export const computePatchedCode = (
  v1ComputePatchedCodeRequest: V1ComputePatchedCodeRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ComputePatchedCodeResponse>> => {
  return axios.default.post(
    `/jarvis.v1.JarvisService/ComputePatchedCode`,
    v1ComputePatchedCodeRequest,
    options,
  );
};

export const getComputePatchedCodeMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof computePatchedCode>>,
    TError,
    { data: V1ComputePatchedCodeRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof computePatchedCode>>,
  TError,
  { data: V1ComputePatchedCodeRequest },
  TContext
> => {
  const mutationKey = ['computePatchedCode'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof computePatchedCode>>,
    { data: V1ComputePatchedCodeRequest }
  > = props => {
    const { data } = props ?? {};

    return computePatchedCode(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ComputePatchedCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof computePatchedCode>>
>;
export type ComputePatchedCodeMutationBody = V1ComputePatchedCodeRequest;
export type ComputePatchedCodeMutationError = AxiosError<RpcStatus>;

/**
 * @summary ComputePatchedCode applies a patch to a failed execution and returns the complete patched SPy code.
The request contains the execution resource name and the patch to apply.
The response contains the complete patched SPy code ready for re-execution.
 */
export const useComputePatchedCode = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof computePatchedCode>>,
      TError,
      { data: V1ComputePatchedCodeRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof computePatchedCode>>,
  TError,
  { data: V1ComputePatchedCodeRequest },
  TContext
> => {
  const mutationOptions = getComputePatchedCodeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary DescribeGrammar returns the PEG (Parsing Expression Grammar) specification
for SPy code. This allows clients to understand the syntax rules.
 */
export const describeGrammar = (
  v1DescribeGrammarRequest: V1DescribeGrammarRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1DescribeGrammarResponse>> => {
  return axios.default.post(
    `/jarvis.v1.JarvisService/DescribeGrammar`,
    v1DescribeGrammarRequest,
    options,
  );
};

export const getDescribeGrammarMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof describeGrammar>>,
    TError,
    { data: V1DescribeGrammarRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof describeGrammar>>,
  TError,
  { data: V1DescribeGrammarRequest },
  TContext
> => {
  const mutationKey = ['describeGrammar'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof describeGrammar>>,
    { data: V1DescribeGrammarRequest }
  > = props => {
    const { data } = props ?? {};

    return describeGrammar(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DescribeGrammarMutationResult = NonNullable<
  Awaited<ReturnType<typeof describeGrammar>>
>;
export type DescribeGrammarMutationBody = V1DescribeGrammarRequest;
export type DescribeGrammarMutationError = AxiosError<RpcStatus>;

/**
 * @summary DescribeGrammar returns the PEG (Parsing Expression Grammar) specification
for SPy code. This allows clients to understand the syntax rules.
 */
export const useDescribeGrammar = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof describeGrammar>>,
      TError,
      { data: V1DescribeGrammarRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof describeGrammar>>,
  TError,
  { data: V1DescribeGrammarRequest },
  TContext
> => {
  const mutationOptions = getDescribeGrammarMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ExtractBookFunction analyzes the SPy code and returns a list of all
external book function calls referenced in the code. Each connection
includes the connection name, book name, and function name.
 */
export const extractBookFunction = (
  v1ExtractBookFunctionRequest: V1ExtractBookFunctionRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ExtractBookFunctionResponse>> => {
  return axios.default.post(
    `/jarvis.v1.JarvisService/ExtractBookFunction`,
    v1ExtractBookFunctionRequest,
    options,
  );
};

export const getExtractBookFunctionMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractBookFunction>>,
    TError,
    { data: V1ExtractBookFunctionRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractBookFunction>>,
  TError,
  { data: V1ExtractBookFunctionRequest },
  TContext
> => {
  const mutationKey = ['extractBookFunction'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractBookFunction>>,
    { data: V1ExtractBookFunctionRequest }
  > = props => {
    const { data } = props ?? {};

    return extractBookFunction(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtractBookFunctionMutationResult = NonNullable<
  Awaited<ReturnType<typeof extractBookFunction>>
>;
export type ExtractBookFunctionMutationBody = V1ExtractBookFunctionRequest;
export type ExtractBookFunctionMutationError = AxiosError<RpcStatus>;

/**
 * @summary ExtractBookFunction analyzes the SPy code and returns a list of all
external book function calls referenced in the code. Each connection
includes the connection name, book name, and function name.
 */
export const useExtractBookFunction = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof extractBookFunction>>,
      TError,
      { data: V1ExtractBookFunctionRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof extractBookFunction>>,
  TError,
  { data: V1ExtractBookFunctionRequest },
  TContext
> => {
  const mutationOptions = getExtractBookFunctionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ExtractInput analyzes the SPy code and returns a list of all
input variables that must be provided for execution. Each input
includes its name and expected type.
 */
export const extractInput = (
  v1ExtractInputRequest: V1ExtractInputRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ExtractInputResponse>> => {
  return axios.default.post(
    `/jarvis.v1.JarvisService/ExtractInput`,
    v1ExtractInputRequest,
    options,
  );
};

export const getExtractInputMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractInput>>,
    TError,
    { data: V1ExtractInputRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractInput>>,
  TError,
  { data: V1ExtractInputRequest },
  TContext
> => {
  const mutationKey = ['extractInput'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractInput>>,
    { data: V1ExtractInputRequest }
  > = props => {
    const { data } = props ?? {};

    return extractInput(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtractInputMutationResult = NonNullable<
  Awaited<ReturnType<typeof extractInput>>
>;
export type ExtractInputMutationBody = V1ExtractInputRequest;
export type ExtractInputMutationError = AxiosError<RpcStatus>;

/**
 * @summary ExtractInput analyzes the SPy code and returns a list of all
input variables that must be provided for execution. Each input
includes its name and expected type.
 */
export const useExtractInput = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof extractInput>>,
      TError,
      { data: V1ExtractInputRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof extractInput>>,
  TError,
  { data: V1ExtractInputRequest },
  TContext
> => {
  const mutationOptions = getExtractInputMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ExtractOutput analyzes the SPy code and returns a list of all
output variables that are set using the set_output() builtin function.
Each output includes its name, type, and location.
 */
export const extractOutput = (
  v1ExtractOutputRequest: V1ExtractOutputRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ExtractOutputResponse>> => {
  return axios.default.post(
    `/jarvis.v1.JarvisService/ExtractOutput`,
    v1ExtractOutputRequest,
    options,
  );
};

export const getExtractOutputMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractOutput>>,
    TError,
    { data: V1ExtractOutputRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractOutput>>,
  TError,
  { data: V1ExtractOutputRequest },
  TContext
> => {
  const mutationKey = ['extractOutput'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractOutput>>,
    { data: V1ExtractOutputRequest }
  > = props => {
    const { data } = props ?? {};

    return extractOutput(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtractOutputMutationResult = NonNullable<
  Awaited<ReturnType<typeof extractOutput>>
>;
export type ExtractOutputMutationBody = V1ExtractOutputRequest;
export type ExtractOutputMutationError = AxiosError<RpcStatus>;

/**
 * @summary ExtractOutput analyzes the SPy code and returns a list of all
output variables that are set using the set_output() builtin function.
Each output includes its name, type, and location.
 */
export const useExtractOutput = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof extractOutput>>,
      TError,
      { data: V1ExtractOutputRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof extractOutput>>,
  TError,
  { data: V1ExtractOutputRequest },
  TContext
> => {
  const mutationOptions = getExtractOutputMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary GenerateSkeleton transforms SPy source code into a SOP-like skeleton structure
with hierarchical step labels, and returns a source map linking each step
back to its byte range in the original source.
Note that the skeleton itself has spy code like sentences - which need to be
translated by an LLM into human-readable prose. The skeleton and the final SOP
will share the same structure, step labels and source map between them.
 */
export const generateSkeleton = (
  v1GenerateSkeletonRequest: V1GenerateSkeletonRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1GenerateSkeletonResponse>> => {
  return axios.default.post(
    `/jarvis.v1.JarvisService/GenerateSkeleton`,
    v1GenerateSkeletonRequest,
    options,
  );
};

export const getGenerateSkeletonMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateSkeleton>>,
    TError,
    { data: V1GenerateSkeletonRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateSkeleton>>,
  TError,
  { data: V1GenerateSkeletonRequest },
  TContext
> => {
  const mutationKey = ['generateSkeleton'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateSkeleton>>,
    { data: V1GenerateSkeletonRequest }
  > = props => {
    const { data } = props ?? {};

    return generateSkeleton(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateSkeletonMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateSkeleton>>
>;
export type GenerateSkeletonMutationBody = V1GenerateSkeletonRequest;
export type GenerateSkeletonMutationError = AxiosError<RpcStatus>;

/**
 * @summary GenerateSkeleton transforms SPy source code into a SOP-like skeleton structure
with hierarchical step labels, and returns a source map linking each step
back to its byte range in the original source.
Note that the skeleton itself has spy code like sentences - which need to be
translated by an LLM into human-readable prose. The skeleton and the final SOP
will share the same structure, step labels and source map between them.
 */
export const useGenerateSkeleton = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateSkeleton>>,
      TError,
      { data: V1GenerateSkeletonRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateSkeleton>>,
  TError,
  { data: V1GenerateSkeletonRequest },
  TContext
> => {
  const mutationOptions = getGenerateSkeletonMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary PrepareCodeManifest analyzes SPy code and produces a manifest describing
its code hash, interface, step tree, source locations, and audit checklist.
The RPC always succeeds at the gRPC level; the response contains a validation
result and, when validation passes, a CodeManifest.
 */
export const prepareCodeManifest = (
  v1PrepareCodeManifestRequest: V1PrepareCodeManifestRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1PrepareCodeManifestResponse>> => {
  return axios.default.post(
    `/jarvis.v1.JarvisService/PrepareCodeManifest`,
    v1PrepareCodeManifestRequest,
    options,
  );
};

export const getPrepareCodeManifestMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof prepareCodeManifest>>,
    TError,
    { data: V1PrepareCodeManifestRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof prepareCodeManifest>>,
  TError,
  { data: V1PrepareCodeManifestRequest },
  TContext
> => {
  const mutationKey = ['prepareCodeManifest'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof prepareCodeManifest>>,
    { data: V1PrepareCodeManifestRequest }
  > = props => {
    const { data } = props ?? {};

    return prepareCodeManifest(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PrepareCodeManifestMutationResult = NonNullable<
  Awaited<ReturnType<typeof prepareCodeManifest>>
>;
export type PrepareCodeManifestMutationBody = V1PrepareCodeManifestRequest;
export type PrepareCodeManifestMutationError = AxiosError<RpcStatus>;

/**
 * @summary PrepareCodeManifest analyzes SPy code and produces a manifest describing
its code hash, interface, step tree, source locations, and audit checklist.
The RPC always succeeds at the gRPC level; the response contains a validation
result and, when validation passes, a CodeManifest.
 */
export const usePrepareCodeManifest = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof prepareCodeManifest>>,
      TError,
      { data: V1PrepareCodeManifestRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof prepareCodeManifest>>,
  TError,
  { data: V1PrepareCodeManifestRequest },
  TContext
> => {
  const mutationOptions = getPrepareCodeManifestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary SearchBuiltinFunctions searches for builtin functions supported by Jarvis.
This endpoint returns ranked builtin functions that best match the provided query.
Each result includes the builtin function name, description, signature, and examples, and a relevance score.
 */
export const searchBuiltinFunctions = (
  v1SearchBuiltinFunctionsRequest: V1SearchBuiltinFunctionsRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1SearchBuiltinFunctionsResponse>> => {
  return axios.default.post(
    `/jarvis.v1.JarvisService/SearchBuiltinFunctions`,
    v1SearchBuiltinFunctionsRequest,
    options,
  );
};

export const getSearchBuiltinFunctionsMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchBuiltinFunctions>>,
    TError,
    { data: V1SearchBuiltinFunctionsRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchBuiltinFunctions>>,
  TError,
  { data: V1SearchBuiltinFunctionsRequest },
  TContext
> => {
  const mutationKey = ['searchBuiltinFunctions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchBuiltinFunctions>>,
    { data: V1SearchBuiltinFunctionsRequest }
  > = props => {
    const { data } = props ?? {};

    return searchBuiltinFunctions(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchBuiltinFunctionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchBuiltinFunctions>>
>;
export type SearchBuiltinFunctionsMutationBody =
  V1SearchBuiltinFunctionsRequest;
export type SearchBuiltinFunctionsMutationError = AxiosError<RpcStatus>;

/**
 * @summary SearchBuiltinFunctions searches for builtin functions supported by Jarvis.
This endpoint returns ranked builtin functions that best match the provided query.
Each result includes the builtin function name, description, signature, and examples, and a relevance score.
 */
export const useSearchBuiltinFunctions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchBuiltinFunctions>>,
      TError,
      { data: V1SearchBuiltinFunctionsRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchBuiltinFunctions>>,
  TError,
  { data: V1SearchBuiltinFunctionsRequest },
  TContext
> => {
  const mutationOptions = getSearchBuiltinFunctionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * ValidateAop checks a business-readable AOP (Automation Operating Procedure)
document against a previously-computed CodeManifest, confirming the AOP's
step list and outputs table stay in lockstep with the code's structure.
This is a pure check — it does not parse or analyze SPy code itself, and
expects the caller to supply a CodeManifest obtained from a prior
PrepareCodeManifest call.
 * @summary Deprecated: In AOP v2 the AOP document is generated deterministically from
the CodeManifest (see PrepareCodeManifestResponse.aop). A generated AOP is a
pure projection of the manifest and cannot drift from the code, so there is
nothing to validate — regenerate from the manifest instead of validating.
Staleness against changed code is detected via CodeManifest.code_hash.
 */
export const validateAop = (
  v1ValidateAopRequest: V1ValidateAopRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ValidateAopResponse>> => {
  return axios.default.post(
    `/jarvis.v1.JarvisService/ValidateAop`,
    v1ValidateAopRequest,
    options,
  );
};

export const getValidateAopMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateAop>>,
    TError,
    { data: V1ValidateAopRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateAop>>,
  TError,
  { data: V1ValidateAopRequest },
  TContext
> => {
  const mutationKey = ['validateAop'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateAop>>,
    { data: V1ValidateAopRequest }
  > = props => {
    const { data } = props ?? {};

    return validateAop(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateAopMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateAop>>
>;
export type ValidateAopMutationBody = V1ValidateAopRequest;
export type ValidateAopMutationError = AxiosError<RpcStatus>;

/**
 * @summary Deprecated: In AOP v2 the AOP document is generated deterministically from
the CodeManifest (see PrepareCodeManifestResponse.aop). A generated AOP is a
pure projection of the manifest and cannot drift from the code, so there is
nothing to validate — regenerate from the manifest instead of validating.
Staleness against changed code is detected via CodeManifest.code_hash.
 */
export const useValidateAop = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validateAop>>,
      TError,
      { data: V1ValidateAopRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof validateAop>>,
  TError,
  { data: V1ValidateAopRequest },
  TContext
> => {
  const mutationOptions = getValidateAopMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ValidateCode validates the provided SPy code using static analysis.
By default, this includes syntax (parse) and semantic/type checks.
When ValidateCodeRequest.syntax_only is true, only syntax (parse) checks are performed.
In syntax-only mode, ValidateCodeRequest.connections is ignored.
 */
export const validateCode = (
  v1ValidateCodeRequest: V1ValidateCodeRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ValidateCodeResponse>> => {
  return axios.default.post(
    `/jarvis.v1.JarvisService/ValidateCode`,
    v1ValidateCodeRequest,
    options,
  );
};

export const getValidateCodeMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateCode>>,
    TError,
    { data: V1ValidateCodeRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateCode>>,
  TError,
  { data: V1ValidateCodeRequest },
  TContext
> => {
  const mutationKey = ['validateCode'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateCode>>,
    { data: V1ValidateCodeRequest }
  > = props => {
    const { data } = props ?? {};

    return validateCode(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateCode>>
>;
export type ValidateCodeMutationBody = V1ValidateCodeRequest;
export type ValidateCodeMutationError = AxiosError<RpcStatus>;

/**
 * @summary ValidateCode validates the provided SPy code using static analysis.
By default, this includes syntax (parse) and semantic/type checks.
When ValidateCodeRequest.syntax_only is true, only syntax (parse) checks are performed.
In syntax-only mode, ValidateCodeRequest.connections is ignored.
 */
export const useValidateCode = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validateCode>>,
      TError,
      { data: V1ValidateCodeRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof validateCode>>,
  TError,
  { data: V1ValidateCodeRequest },
  TContext
> => {
  const mutationOptions = getValidateCodeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary ValidatePatch validates a patch against the ambient scope of the
execution's currently failing statement — as if it were applied at that
location — without mutating the execution's checkpoint.
Includes syntax (parse) and semantic/type checks.
 */
export const validatePatch = (
  v1ValidatePatchRequest: V1ValidatePatchRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ValidatePatchResponse>> => {
  return axios.default.post(
    `/jarvis.v1.JarvisService/ValidatePatch`,
    v1ValidatePatchRequest,
    options,
  );
};

export const getValidatePatchMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validatePatch>>,
    TError,
    { data: V1ValidatePatchRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validatePatch>>,
  TError,
  { data: V1ValidatePatchRequest },
  TContext
> => {
  const mutationKey = ['validatePatch'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validatePatch>>,
    { data: V1ValidatePatchRequest }
  > = props => {
    const { data } = props ?? {};

    return validatePatch(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidatePatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof validatePatch>>
>;
export type ValidatePatchMutationBody = V1ValidatePatchRequest;
export type ValidatePatchMutationError = AxiosError<RpcStatus>;

/**
 * @summary ValidatePatch validates a patch against the ambient scope of the
execution's currently failing statement — as if it were applied at that
location — without mutating the execution's checkpoint.
Includes syntax (parse) and semantic/type checks.
 */
export const useValidatePatch = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validatePatch>>,
      TError,
      { data: V1ValidatePatchRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof validatePatch>>,
  TError,
  { data: V1ValidatePatchRequest },
  TContext
> => {
  const mutationOptions = getValidatePatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
